import { useTranslation } from 'react-i18next';

import { getEvaluationDepartmentSignedSummaryFileDownloadUrl } from '@/module/Evaluation/model/EvaluationApi';
import { useEvaluationUploadDepartmentSummaryFile } from '@/module/Evaluation/model/EvaluationQuery';

import { Id, PersistentFile, useAppNotification } from '@feature/utils';

import { EvaluationAuthorFile } from './EvaluationAuthorFile';

interface EvaluationDepartmentSummaryFileProps {
  departmentId: Id;
  evaluationId: Id;
  file: PersistentFile | null;
}

export function EvaluationDepartmentSummaryFile({
  evaluationId,
  departmentId,
  file,
}: EvaluationDepartmentSummaryFileProps) {
  const { mutate, isPending } = useEvaluationUploadDepartmentSummaryFile(evaluationId, departmentId);
  const notification = useAppNotification();
  const { t } = useTranslation();

  const onUpload = (newFile: File) => {
    mutate(newFile, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <EvaluationAuthorFile
      onUpload={onUpload}
      file={file}
      onDownload={() => window.open(getEvaluationDepartmentSignedSummaryFileDownloadUrl(evaluationId, departmentId))}
      isSubmitting={isPending}
      label={t('evaluation.files.departmentSummary.label')}
      description={t('evaluation.files.departmentSummary.description')}
    />
  );
}
